import React from "react";
import { Heart } from "lucide-react";
import { useFavorites } from "../lib/favorites";
import { useAuth } from "../lib/auth";
import { useNavigate } from "react-router-dom";

export default function FavoriteButton({ listingId, size = 18, className = "" }) {
  const { isFav, toggle } = useFavorites();
  const { user } = useAuth();
  const nav = useNavigate();
  const favored = isFav(listingId);

  const onClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!user) { nav("/login"); return; }
    await toggle(listingId);
  };

  return (
    <button
      data-testid={`fav-btn-${listingId}`}
      data-favored={favored}
      onClick={onClick}
      className={`inline-flex items-center justify-center rounded-full bg-white/95 border border-[#E6E2D8] hover:bg-white transition-colors ${className}`}
      style={{ width: size + 16, height: size + 16 }}
      aria-label={favored ? "Unfavorite" : "Favorite"}
    >
      <Heart
        size={size}
        strokeWidth={1.5}
        fill={favored ? "#143122" : "none"}
        color={favored ? "#143122" : "#1A1F1C"}
      />
    </button>
  );
}
